import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import '../assets/css/components/image-header.css';

const ImageHeader = ({ titleContents, id, image, subtitleText, children, containerClass }) => {
  const getCoverStyle = (image) => {
    if(!_.isNil(image)){ return { backgroundImage: `url(${image})` } }
  }

  return(
    <div id={id} className="bg-app-white social-wrapper" data-testid='ImageHeader-greeting-text'>
      <div className="social" data-pages="social">
        <div className="no-print jumbotron" data-social="cover">
          <div className="cover-photo" style={getCoverStyle(image)}></div>
          <div className="container-fluid sm-p-l-0 sm-p-r-0">
            <div className="inner">
              <div className="pull-bottom bottom-left m-b-40 sm-p-l-15">
                <h5 className="text-white no-margin">{subtitleText}</h5>
                <h1 className="text-white no-margin ImageHeader-greeting-text">{titleContents}</h1>
              </div>
            </div>
          </div>
        </div>
        <div className={`${containerClass} container-fluid container-primary container-fixed-lg sm-p-l-0 sm-p-r-0`}>
          <div className="day">
            <div className="children-wrapper">
              {children}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

const { oneOfType, string, object } = PropTypes
ImageHeader.propTypes = {
  titleContents:  oneOfType([ string, object ]),
  image:          string.isRequired
}

export default ImageHeader
